var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("app-contact-search", {
        attrs: { value: _vm.singleValue, fancy: "", label: _vm.label },
        on: {
          input: function ($event) {
            return _vm.setSingleValue($event)
          },
        },
      })
    : _vm.multi
    ? _c(
        "w-col",
        { attrs: { xs: "12", "no-margin": "" } },
        [
          _c("app-contact-search", {
            attrs: { value: null, fancy: "", label: _vm.label },
            on: {
              input: function ($event) {
                return _vm.addContact($event)
              },
            },
          }),
          _c(
            "div",
            _vm._l(_vm.contacts, function (contact, i) {
              return _c(
                "w-chip",
                {
                  key: i,
                  staticClass: "chip",
                  attrs: { closable: "" },
                  on: {
                    close: function ($event) {
                      return _vm.removeContact(i)
                    },
                  },
                },
                [_vm._v(_vm._s(contact.getDisplayName()))]
              )
            }),
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }